import { db } from "../firebase/firebase";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { useState, useEffect } from "react";

const useNewMessage = (userUid: string) => {
  const [unreadCount, setUnreadCount] = useState<number | null>(null);

  useEffect(() => {
    const messagesQuery = query(
      collection(db, "messages"),
      where("recipient", "==", userUid),
      where("status", "==", "unread")
    );

    const unsubscribe = onSnapshot(
      messagesQuery,
      (querySnapshot) => {
        if (!querySnapshot.empty) {
          setUnreadCount(querySnapshot.size); 
        } else {
          setUnreadCount(null); 
        }
      },
      (error) => {
        console.error("Error listening for new messages: ", error);
        setUnreadCount(null); // In case of error, return null
      }
    );

    return () => unsubscribe();
  }, [userUid]);

  return unreadCount;
};

export default useNewMessage;
